import React, {useState} from 'react';
import { styled } from 'linaria/react';
import { ReactComponent as Copy } from './Copy.svg';
import { ReactComponent as Mail } from './Mail.svg';
import { ReactComponent as Close } from '../../../svg/Cross.svg';
import t from '@jetshop/intl';

const PopupBackground = styled('div')`
position: fixed;
top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgb(0, 0, 0, 0.5);
  z-index: 3;
`

const PopupWrapper = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 15px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100;
  max-width: 350px;
  
  @media screen and (max-width: 800px) {
    position: fixed;
    box-shadow: 0px 0px 5px #000;
    border-radius: 20px;
    width: 350px;
    max-width: 90vw;
  }
`

const PopupHeader = styled('p')`
  font-size: 20px;
  margin: 0 auto 10px;
  font-weight: 600;
`

const PopupText = styled('p')`
`

const PopupInput = styled('input')`
  width: 100%;
  padding: 10px;
  margin: 10px auto 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  
  &.error {
    border-color: #911827;
  }
`

const PopupButton = styled('button')`
  height: 35px;
  text-transform: uppercase;
  width: 100%;
  font-size: 14px;
  border-radius: 50px;
  margin: 0 auto;
  background: #911827;
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 15px;

  &:hover {
    background: #720714;
    svg {
      path {
        stroke: #fff;
      }
    }
  }

  @media screen and (max-width: 800px) {
    height: 30px;
    width: 100%;
    margin: 0 0;
  }

  svg {
    height: 20px;
    width: auto;
    path {
      stroke: #fff;
      fill: transparent;
    }
  }
`

const PopupButtonIcon = styled('div')`
  width: auto;
  height: 20px;
`

const PopupCloseButton = styled('span')`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  padding: 0;
  
  svg {
    width: 15px;
    height: 15px;
    path {
      stroke: #000;
      fill: transparent;
    }
  }
`


const Popup = ({ url, onClose }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);
  const [copied, setCopied] = useState(false);
  const [placeholder, setPlaceholder] = useState('E-postadress');

  const subject = encodeURIComponent('Kolla in denna 3D-modell');
  const body = encodeURIComponent(
    `Här är länken till din konfigurerade modell:\n${window.location.protocol}//${window.location.host}${window.location.pathname}?config=${url}`
  );

  const handleMailClick = () => {
    if (!email) {
      setError(true)
      setPlaceholder('Ange en giltig e-postadress');
    } else {
      setError(false)
      window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
    }
  };

  return (
    <>
      <PopupBackground></PopupBackground>
      <PopupWrapper>
        <PopupCloseButton onClick={onClose}><Close /></PopupCloseButton>
        <PopupHeader>{t('Dela din soffdesign!')}</PopupHeader>
        <PopupText>{t('Skicka en direktlänk till valfri e-postadress:')}</PopupText>
        <PopupInput
          type={'text'}
          placeholder={placeholder}
          value={email}
          onChange={e => setEmail(e.target.value)}
          className={error ? 'error' : ''}
        />
        <PopupButton onClick={handleMailClick}>
          <PopupButtonIcon><Mail /></PopupButtonIcon>
          {t('Skicka via e-post')}
        </PopupButton>
        <PopupText>{t('Eller klicka på knappen för att kopiera länken')}</PopupText>
        <PopupButton onClick={() => {
          navigator.clipboard.writeText(window.location.protocol + '//' + window.location.host + window.location.pathname + '?config=' + url)
          setCopied(true);
          setTimeout(() => setCopied(false), 5000)
        }}>
          <PopupButtonIcon><Copy /></PopupButtonIcon>
          <span>{copied ? t('Kopierad...') : t('Kopiera länk')}</span>
        </PopupButton>
      </PopupWrapper>
    </>
  );
};
export default Popup;